import DatasetsMutator from "@/modules/datasets/datasets-mutator";
import { useInterventionSectionContext } from "@/modules/intervention/intervention-section-context";

const InterventionSectionDatasetsMutator = () => {
  const {
    intervention,
    layoutIndex,
    assetId,
    observationId,
    onObservationCreate,
    onDatasetDelete,
  } = useInterventionSectionContext();

  const menuQueryKey = ["interventions", "menu", intervention.id];
  const datasetsQueryKey = ["observations", "get", observationId];

  return (
    <DatasetsMutator
      interventionId={intervention.id}
      sectionLayoutIndex={layoutIndex}
      sectionAssetId={assetId}
      sectionObservationId={observationId}
      onObservationCreate={onObservationCreate}
      onDatasetDelete={onDatasetDelete}
      // On create & update, always invalidate menu & datasets to make sure
      // data is up to date: datasets data + section progress in menu + section
      // params (with or without observation_id)
      createInvalidateKeys={[menuQueryKey, datasetsQueryKey]}
      updateInvalidateKeys={[menuQueryKey, datasetsQueryKey]}
      // On delete, let's just invalidate menu. The datasets invalidation will be
      // handled in `useInterventionSectionRedirect()` to avoid 404 datasets
      // fetch errors happening before the section redirection.
      deleteInvalidate={[{ queryKey: menuQueryKey, mode: "background" }]}
    />
  );
};

export default InterventionSectionDatasetsMutator;
